export default {
  title: 'Portal Comenzi',
  form: {
    username: {
      placeholder: 'Nume utilizator',
    },
    password: {
      placeholder: 'Parolă',
    },
  },
  buttons: {
    submit: 'Autentificare',
  },
  toasts: {
    auth_token_invalid: 'Tokenul de autentificare furnizat este invalid, vă rugăm să vă conectați cu credențialele',
    credentials_invalid: 'Nume utilizator sau parolă incorectă',
  },
};
